module.exports = __webpack_public_path__ + "components/country-flag/static/sj-c3e0343a649e0abb72d82f48e653a729.svg";